<template>
<section class="tim-section ui-section">
    <div class="ui-max-width">
        <ui-head class="txt-center">
            <template #head><h3 v-html="$t('timeline_head')"></h3></template>
            <template #subhead>{{$t('timeline_p')}}</template>
        </ui-head>
        <ui-timeline class="ui-timeline" :ImageSrc="require(`@/assets/images/screening.png`)">
            <template #title><h4 class="tim-heading">{{$t('timeline_stage1')}}</h4></template>
            <template #content>
                <p>{{$t('timeline_stage1_p')}}</p>
                <p>{{$t('timeline_stage1_p2')}}</p>
                <p>{{$t('timeline_stage1_p3')}}</p>
                <p>{{$t('timeline_stage1_p3a')}}</p>
            </template>
        </ui-timeline>

        <ui-timeline class="ui-timeline" :ImageSrc="require(`@/assets/images/treatment.png`)">
            <template #title><h4 class="tim-heading">{{$t('timeline_stage2')}}</h4></template>
            <template #content>
                <p>{{$t('timeline_stage2_p')}}</p>
                <ul class="ui-ts-ul">
                    <li class="list1 ui-ts-li">{{$t('timeline_stage2_p_l1')}}</li>
                    <li class="list2 ui-ts-li">{{$t('timeline_stage2_p_l2')}}</li>
                    <li class="list3 ui-ts-li">{{$t('timeline_stage2_p_l3')}}</li>
                </ul>
                <p>{{$t('timeline_stage2_p2')}}</p>
            </template>
        </ui-timeline>

        <ui-timeline class="ui-timeline" :ImageSrc="require(`@/assets/images/follow-up.png`)">
            <template #title><h4 class="tim-heading">{{$t('timeline_stage3')}}</h4></template>
            <template #content>
                <p>{{$t('timeline_stage3_p')}}</p>
            </template>
        </ui-timeline>

        <leftee-layout>
            <ui-abutton href="#js-eligible" class="elig-btn btn--secondary" v-smooth-scroll>{{$t('ats_btn_label')}}</ui-abutton>
        </leftee-layout>
    </div>



</section>
</template>

<script>
import UiHeadingVue from '../../components/UiHeading.vue'
import UiTimelineVue from '../../components/UiTimeline.vue'
import CenteredLayoutVue from '../../components/layout/CenteredLayout.vue'
import UiAnchorButtonVue from '../../components/UiAnchorButton.vue'

export default {
    components: {
        'ui-timeline': UiTimelineVue,
        "ui-head": UiHeadingVue,
        "ui-abutton": UiAnchorButtonVue,
    "leftee-layout": CenteredLayoutVue
    }
}
</script>

<style lang="scss">
    .tim-section {
        background-color: $tim-section-bg-color;
    }
    
    .ui-timeline .ui-tim-img-wrap {
        background-color: $timline-img-bg-color;
    }
    
    .ui-timeline .tim-heading{
        max-width: 177px;
        text-align: left;
        line-height: 1.5;
        color: #A8B1BD;
        font-size: 18px;
        letter-spacing: 1px;
    
        @media screen and (min-width: 767px) {
            text-align: right;
        }
    }
    </style>
    